export default "__VITE_ASSET__153bda66__"